import S3 from 'aws-sdk/clients/s3'
import moment from 'moment'
import { Api } from '.'

export interface FileToUpload {
    base64: string
    ext: string
}

export const fileToBase64 = (file: File): Promise<FileToUpload> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
            const result = e.target?.result as string
            const base64 = result.split(',')[1]
            const ext = file.name.split('.').pop() || 'png'
            resolve({ base64, ext })
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
    })

export const uploadToSpaces = async (files: FileToUpload[], folder: string): Promise<string[]> => {
    if (!files.length) return []

    const awsData: any = await Api({
        controller: 'Users',
        action: 'fetchAWSCredentials'
    })

    const { accessKeyId, secretAccessKey, endpoint, bucket } = awsData
    const bucketName = bucket || 'spottechs'

    const s3 = new S3({
        accessKeyId,
        secretAccessKey,
        endpoint,
        signatureVersion: 'v4',
        s3ForcePathStyle: true,
    })

    const uploads = files.map(async ({ base64, ext }, index) => {
        const date = moment().format('YYYY-MM-DD-HH-mm-s')
        const fileName = `spotpoool/${folder}/${date}/${index}/image.${ext}`

        const binary = atob(base64)
        const bytes = new Uint8Array(binary.length)
        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
        const body = new Blob([bytes], { type: `image/${ext}` })

        const result = await s3.upload({
            Bucket: bucketName,
            Key: fileName,
            Body: body,
            ContentType: `image/${ext}`,
            ACL: 'public-read'
        }).promise()

        return result.Location
    })

    return Promise.all(uploads)
}
